import Store from 'lightningjs-redux';
import { createItemAction } from '../../cta/cta.actions';
import { saveSearchedItem } from '../../../logic/search/search.actions';
import { AbstractLayout } from '../../layout/abstractLayout.component';

export default class SearchResultBlock extends AbstractLayout {
  get hasResults() {
    return this.tag('Blocks').children.length !== 0;
  }

  set hasSideNav(value) {
    this._hasSideNav = false;
  }

  set data(value) {
    this._viewportWidth = this.finalW;
    this._viewportHeight = this.finalH;
    super.data = value;
  }

  _handleSelected(item) {
    Store.dispatch(saveSearchedItem(item));
    Store.dispatch(createItemAction({ item }));
  }

  _setIndex(index = this._index, shouldAnimate = false) {
    const position = this._positions[index];
    if (!Number.isFinite(position)) {
      return;
    }
    const offset = index === 0 ? this._verticalOffset : 0;
    this._offset = position + offset;
    this._index = index;

    if (shouldAnimate) {
      this.tag('Blocks').setSmooth('y', this._offset);
    } else {
      this.tag('Blocks').y = this._offset;
    }
  }
}
